module.exports = __webpack_public_path__ + "static/Asset_5barcode-2-4993a6bbf8fcb87e889e95ce2fa4c644.svg";